export enum EnvironmentName {
  local = 'local',
  dev = 'dev',
  stg = 'stg',
  prd = 'prd',
}
